"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _evergreenUi = require("evergreen-ui");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SelectionTableCell = function SelectionTableCell(_ref) {
  var dataRow = _ref.dataRow,
    dataKey = _ref.dataKey,
    selectedRowIds = _ref.selectedRowIds,
    _onChange = _ref.onChange,
    width = _ref.width;
  return /*#__PURE__*/_react["default"].createElement(_evergreenUi.Table.Cell, {
    justifyContent: "center",
    flexGrow: width
  }, /*#__PURE__*/_react["default"].createElement(_evergreenUi.Checkbox, {
    checked: selectedRowIds.includes(dataRow[dataKey]),
    onChange: function onChange() {
      return _onChange(dataRow[dataKey]);
    }
  }));
};
SelectionTableCell.propTypes = {
  dataRow: _propTypes["default"].object.isRequired,
  dataKey: _propTypes["default"].string.isRequired,
  selectedRowIds: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  onChange: _propTypes["default"].func,
  width: _propTypes["default"].number
};
SelectionTableCell.defaultProps = {
  width: 1
};
var _default = exports["default"] = SelectionTableCell;